import React, { Component } from 'react';
import DrawerToggleButton from '../SideDrawer/DrawerToggleButton';
import SideDrawer from '../SideDrawer/SideDrawer';
import { connect } from 'react-redux';
import * as actions from '../../store/actions/index';
import { NavLink } from 'react-router-dom';
import './Toolbar.scss';

class Tollbar extends Component {
  navToggleHandler = () => {
    this.props.onToggleNav();
  };

  render() {
    return (
      <header className="toolbar">
        <SideDrawer {...this.props} />
        <nav className="toolbar__navigation">
          <DrawerToggleButton
            clicked={this.navToggleHandler}
            open={this.props.showSideDrawer}
          />
          <div className="toolbar__logo">
            <NavLink to="/" className="toolbar__logo-link">
              Logo
            </NavLink>
          </div>
          <div className="react-autosuggest">
            <div className="search-container">
              <div className="search-container-wrapper">
                {this.props.children}
              </div>
            </div>
          </div>
          <div className="toolbar__navigation-items">
            <ul>
              <li>
                <NavLink to="/" className="toolbar__navigation-home">
                  Home
                </NavLink>
              </li>
              {!this.props.isAuthenticated ? (
                <li>
                  <NavLink to="/login" className="toolbar__navigation-login">
                    Login
                  </NavLink>
                </li>
              ) : (
                <li>
                  <NavLink
                    to={`/user/${this.props.userName}`}
                    className="toolbar__navigation-dashboard">
                    Login
                  </NavLink>
                </li>
              )}
              <li>
                <NavLink to="/search" className="toolbar__navigation-search">
                  Search
                </NavLink>
              </li>
            </ul>
          </div>
        </nav>
      </header>
    );
  }
}

const mapStateToProps = state => ({
  showSideDrawer: state.toggleNavReducer.showSideDrawer,
  isAuthenticated: state.authReducer.token !== null,
  userName: state.authReducer.userName
});

const mapDispatchToProps = dispatch => ({
  onToggleNav: () => dispatch(actions.toggleNav())
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Tollbar);
